import cloneDeep from 'lodash/cloneDeep'
import { parseF2Color } from '@constants/echart'

const isOwnEmpty = obj => Object.keys(obj).length === 0

const parseTranslateX = (string) => {
  if (!string) return 0
  const group = /translateX\((.*)\)/.exec(string)

  if (!group || !group[1]) return 0
  return Number.parseFloat(group[1])
}
/**
 * 获取对象中的指定属性
 * @param obj
 * @param attr
 * @return {*}
 */
const retain = (obj, attr) => {
  const newObj = {}
  if (!attr) {
    return {
      ...obj
    }
  }

  const attrs = Array.isArray(attr) ? attr : [attr]

  Object.entries(obj).forEach(([key, value]) => {
    if (attrs.includes(key)) {
      newObj[key] = cloneDeep(value)
    }
  })

  return newObj
}

/**
 * 合并单图 config
 * @param props
 * @param config
 */
const combineChartConfig = (props, config) => {
  const chartRetain = [
    'height',
    'width',
    'padding',
    'pixelRatio',
    'appendPadding',
    'plugins',
    'syncY'
  ]

  config.chart = retain(props, chartRetain)
}

/**
 * 合并数据 config
 * @param props
 * @param config
 */
const combineDataConfig = (props, config) => {
  const { data, defs } = props
  if (data) {
    config.data = cloneDeep(data)
  }

  if (defs) {
    config.defs = cloneDeep(defs)
  }
}

/**
 * 合并动画 config
 * @param props
 * @param config
 */
const combineAnimateConfig = (props, config) => {
  config.animate = cloneDeep(props.animate)
}

/**
 * 合并组件 config
 * @param type
 * @param props
 * @param config
 * @return {*}
 */
const combineContentConfig = (type, props, config) => {
  const nameLowerCase = type.toLowerCase()

  const regSeries = ['line', 'area', 'bar', 'interval', 'point', 'schema']

  if (!regSeries.includes(type) && isOwnEmpty(props)) {
    config[nameLowerCase] = true
  } else if (regSeries.includes(type)) {
    if (!config.series) {
      config.series = []
    }

    config.series.push({
      geom: type,
      ...props
    })
  } else if (nameLowerCase === 'axis') {
    if (!config.axis) {
      config.axis = []
    }
    config.axis.push(props)
  } else if (nameLowerCase === 'series') {
    if (!config.series) {
      config.series = []
    }
    config.series.push(props)
  } else if (nameLowerCase === 'guide') {
    if (!config.guide) {
      config.guide = []
    }
    config.guide.push(props)
  } else if (nameLowerCase === 'pielabel') {
    if (!isOwnEmpty(props)) {
      config.pieLabel = props
    }
  } else {
    config[nameLowerCase] = props
  }

  return config
}

const mergeDataLegend = (data, legends) => {
  if (!Array.isArray(legends)) return []

  if (!Array.isArray(data) || data.length <= 0) {
    return legends.map(({ dataValue, marker, ...rest }) => ({
      title: '',
      value: '',
      ...rest,
      color: (marker && marker.fill) || '#ccc',
      name: dataValue
    }))
  }

  return legends.map(({ dataValue, checked, marker, ...rest }) => {
    const item = data.find(d => d.name === dataValue)
    if (item) {
      return {
        ...item,
        ...rest,
        color: (marker && marker.fill) || '#ccc',
        checked
      }
    }
    return {
      title: '',
      value: '',
      ...rest,
      color: checked ? (marker && marker.fill) : '#ccc',
      name: dataValue,
      checked,
    }
  })
}

/**
 * element contain element
 * @param root
 * @param n
 * @return {boolean}
 */
export const contains = (root, n) => {
  if (!root || !n) return false

  let node = n
  while (node) {
    if (node === root) {
      return true
    }
    node = node.parentNode
  }

  return false
}

export {
  mergeDataLegend,
  combineChartConfig,
  combineDataConfig,
  combineAnimateConfig,
  parseTranslateX,
  combineContentConfig,
  retain,
  parseF2Color
}
